module.exports = __webpack_public_path__ + "img/pop_yellow.add09513.png";